import React, { useState } from 'react';
import { Icon, Feed, Header, Label } from 'semantic-ui-react'
// import './Card.css';
import Share from './Share'
import AboutPill from './AboutPill'

// Theme-aware styles for dates and counts
const dateStyle = {
  color: 'var(--muted-foreground)',
  fontSize: '11px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
};

const countStyle = {
  color: 'var(--sidebar-foreground)',
  fontWeight: '500',
  marginLeft: '2px'
};

function CircuitName(props) {
  // The server-rendered About panel carries the page's single h1; where it is
  // present the title here is a div with the same classes (lab, assignments keep the h1).
  const titleInPanel = !!props.has_about || (typeof document !== 'undefined' && !!document.getElementById('circuit-about'));
  const TitleTag = titleInPanel ? 'div' : 'h1';


  const feed = (
    <Feed size='small' style={{ paddingTop: 5 }}>
      <Feed.Event style={{ paddingLeft: 15 }} >

        <Feed.Content style={{ marginLeft: 0 }}>
          <Feed.Summary>

            <Feed.Label id="title_wrapper">
              {
                <TitleTag className='title dcgreen' style={titleInPanel ? { fontWeight: 700, lineHeight: '1.28em' } : undefined}>
                  {props.assignment != null ? `${l.assignment}:${props.assignment.name}` : props.title}
                </TitleTag>
              }

            </Feed.Label>

            {action_name != 'assignment' && props.circuit && action_name != "lab" &&
              <Feed.Date style={dateStyle}>
                <span style={{ color: 'var(--muted-foreground)' }}>{props.circuit.created_at}</span>
                {props.is_public && <Icon name='eye' style={{ color: 'var(--sidebar-foreground)', margin: '0 2px' }} />}
                {props.is_public && <span style={countStyle}>{props.circuit.impressionist_count}</span>}
              </Feed.Date>
            }

            {props.assignment &&
              <Feed.Date style={dateStyle}>
                <p style={{ color: 'var(--muted-foreground)', margin: 0 }}>By {props.assignment.submission_date}</p>
              </Feed.Date>
            }

          </Feed.Summary>
        </Feed.Content>
      </Feed.Event>

    </Feed>
  )

  if (!props.has_about) return feed;
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <AboutPill label={l.about_circuit} />
      {feed}
    </div>
  )
}

export default CircuitName
